<mat-dialog-content class="mat-typography">
    <p>{{error || 'Something went wrong...'}}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="closeDialog(data.actions.confirm)">{{data.actions.confirm.label}}</button>
    <button *ngIf="cancel" mat-button (click)="cancel.effect()">{{cancel.label}}</button>
</mat-dialog-actions>